export default __webpack_public_path__ + "static/media/slider03.45b5f1e7.png";